// extracted by mini-css-extract-plugin
export default {"page":"CaseStudies_page__oUP-p","header":"CaseStudies_header__N274h","grid":"CaseStudies_grid__Paff-","cards":"CaseStudies_cards__mu+-E"};